import { DELETE_COMMENT, LOAD_COMMENTS, LOAD_THREAD, LOAD_THREADS, POST_COMMENT } from './actions';


const initialState = {
  /**
   * The model these comments are loaded for
   */
  model: '',

  /**
   * The model ID for the comments to load
   */
  id: 0,

  /**
   * Comments three for the model and id
   */
  comments: [],

  /**
   * To manage comments
   */
  threads: {
    total: 0,
    list: [],
  },

  /**
   * A single comments with replies
   */
  thread: [],
};

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case LOAD_COMMENTS.REQUEST:
      return initialState;
    case LOAD_COMMENTS.SUCCESS:
      return {
        ...state,
        model: action.data.model,
        id: action.data.id,
        comments: action.payload.comments,
      };
    case LOAD_THREAD.SUCCESS:
      return {
        ...state,
        thread: action.payload.comments,
      };
    case LOAD_THREADS.SUCCESS:
      return {
        ...state,
        threads: {
          total: action.payload.meta.total,
          list: action.payload.comments,
        }
      };
    case DELETE_COMMENT.SUCCESS:
      return {
        ...state,
        threads: {
          total: state.threads.total - 1,
          list: state.threads.list.filter(cmm => cmm.id !== action.data.comment.id),
        }
      };
    case POST_COMMENT.SUCCESS:
      return {
        ...state,
        comments: [...state.comments,action.payload.comment],
        thread: [...state.thread, action.payload.comment],
      };
    default:
      return state;
  }
}